/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-inline[_ngcontent-%COMP%]{flex-flow:nowrap}label[_ngcontent-%COMP%]{width:110px;margin-right:10px}.header-area[_ngcontent-%COMP%]{display:-webkit-box;display:flex;margin-bottom:0}.total-planted[_ngcontent-%COMP%]{margin-top:9px;margin-bottom:10px}.select-site[_ngcontent-%COMP%]{border-right:1px solid #c1c1c1!important;min-height:39px}.filter-list[_ngcontent-%COMP%]{width:211px!important}\n/*# sourceMappingURL=planting-sites-shell.component.css.map*/"];
export { styles as styles };
